"use client";
import store from "@store/index";
import { preloadedState } from "@store/preloadedState";
import { QueryClientProvider } from "@tanstack/react-query";
import StyledComponentsRegistry from "@util/antd/AntdRegistry";
import { antdThemeConfig } from "@util/antd/config";
import { ConfigProvider } from "antd";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { SessionProvider } from "next-auth/react";
import { queryClient } from "@util/query";
import OneSignal from "react-onesignal";

export const AppProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const pathname = usePathname();

  const excludePath = (path: string): boolean => {
    const listExcludePath = ["/register"];

    return listExcludePath.some((x) => path.includes(x));
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      OneSignal.init({
        appId: process.env.NEXT_PUBLIC_ONESIGNAL_ID!,
        safari_web_id: process.env.NEXT_PUBLIC_ONESIGNAL_SAFARI_ID!,
        //@ts-ignore
        notifyButton: { enable: true },
      });
    }
  }, []);

  useEffect(() => {
    if (pathname && !excludePath(pathname)) preloadedState();
  }, [pathname]);

  return (
    <Provider store={store}>
      <SessionProvider>
        <ConfigProvider theme={antdThemeConfig}>
          <QueryClientProvider client={queryClient}>
            <StyledComponentsRegistry>{children}</StyledComponentsRegistry>
          </QueryClientProvider>
        </ConfigProvider>
      </SessionProvider>
    </Provider>
  );
};
